import React, { forwardRef } from "react";
import { Input, type InputProps, type InputRef } from "antd";
import { useControlledInputValue } from "./UseControlledInputValue";

type StyledTextInputProps = InputProps;

const StyledTextInput = forwardRef<InputRef, StyledTextInputProps>(
  ({ className, value, defaultValue, onChange, ...props }, ref) => {
    const controlled = useControlledInputValue(value, defaultValue, onChange);

    return (
      <Input
        {...props}
        ref={ref}
        value={controlled.value}
        onChange={controlled.onChange}
        className={`styled-text-input ${
          controlled.hasValue ? "styled-text-input--has-value" : ""
        } ${className || ""}`}
      />
    );
  }
);

StyledTextInput.displayName = "StyledTextInput";

export default StyledTextInput;
